export default __webpack_public_path__ + "5ad4577a9139d0526420a90438086a88.jpg";